<script setup>
import BasicLayout from '@/components/ui/layouts/BasicLayout.vue'
import TopBarBasic from '@/components/ui/topbar/TopBarBasic.vue'
</script>

<template>
  <basic-layout>
    <template #topbar>
      <top-bar-basic />
    </template>
    <app-panel>
      <slot />
    </app-panel>
  </basic-layout>
</template>
